export const CELEBRATION_HELP_URL = 'https://help.bonus.ly/en/articles/11088184-managing-celebrations';
export const CELEBRATION_BLOG_URL = 'https://bonusly.com/resources/blog';
export const ADDING_GROUPS_URL = 'https://help.bonus.ly/en/articles/11380720-adding-groups-of-users-to-bonusly';
